export default "__VITE_ASSET__BY044CkX__"